import React, { Component } from 'react'
import AnimateHeight from 'react-animate-height'
import { connect } from 'react-redux'
import ButtonContainer from './ButtonContainer'
import BoxSearch from './BoxSearch'
class Box extends Component {
  constructor (props) {
    super(props)
    this.state = {
      xs: 'col-xs-' + (this.props.xs || this.props.cols || 12),
      sm: 'col-sm-' + (this.props.sm || this.props.cols || 12),
      md: 'col-md-' + this.props.cols || 12,
      lg: 'col-lg-' + (this.props.lg || this.props.cols || 12),
      updated: Date.now(),
      collapsed: (this.props.collapsable ? (this.props.collapsed !== undefined ? this.props.collapsed : true) : false)
    }
    if (!this.props.deepstream) return
    this.driver = this.props.deepstream.record.getRecord(`users/${this.props.user.id}/boxes/${this.props.identifier}`)
  }
  componentDidMount () {
    if (this.props.collapsable && this.props.identifier) {
      this.driver.whenReady(record => {
        var boxState = record.get('collapsed')
        if (boxState !== undefined) {
          this.setState({ collapsed: boxState })
        }
        record.subscribe('collapsed', collapsed => {
          this.setState({ collapsed: collapsed })
        })
      })
    }
  }
  toggleCollapse () {
    var state = !this.state.collapsed
    this.driver.set('collapsed', state)
  }
  componentWillReceiveProps (props) {
    this.setState({updated: Date.now()})
  }
  render () {
    return (
      <div className={'box ' + (this.props.staticbox ? 'staticbox ' : '') + [this.state.xs, this.state.sm, this.state.md, this.state.lg].join(' ')}>
        <div className='box-inner'>
          <div className='box-header clearfix'>
            <div className='row'>
              <h3 className='box-title col-md-12 ' onClick={() => this.props.collapsable && this.toggleCollapse()}><i className={'box-icon fa fa-fw fa-' + this.props.icon} />{this.props.title} {(this.props.badges && this.props.badges.length !== 0 && this.props.badges.map((badge, i) => <span key={'badge' + i} className={'box-badge badge ' + (badge.type ? 'badge-' + badge.type : '')}>{badge.value}</span>))}</h3>
              <div className='box-buttons text-right'>
                <a className={this.props.collapsable ? 'pull-right box-button' : 'pull-right box-button hidden'} onClick={e => this.toggleCollapse()}><i className={'fa fa-fw fa-arrow-down fa-animate-rotate ' + (this.state.collapsed ? '' : 'fa-rotate-180')} /></a>
                <ButtonContainer updated={this.state.updated} buttons={this.props.buttons} datatip={this.props.datatip} />
                <BoxSearch filter={this.props.filter} />
              </div>
            </div>
          </div>
          <AnimateHeight duration={500} height={(this.state.collapsed ? '0' : 'auto')}>
            <div className='box-content'>
              <div className={'box-content-inner clearfix ' + (this.props.noPadding ? 'no-padding' : '')}>
                {!this.props.dataLoading && this.props.children}
                {this.props.dataLoading &&
                  <div className='no-data-in-table-wrapper'>
                    <div className='no-data-text-wrapper'>
                      <i className='fa fa-circle-o-notch fa-spin' />
                      <h3 className='text-center no-data-text'>Loading</h3>
                    </div>
                  </div>
                }
              </div>
            </div>
          </AnimateHeight>
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
Box = connect(state => state.siteReducer)(Box)
export default Box



// WEBPACK FOOTER //
// ./src/components/basic/containers/Box.js